import { Link } from 'react-router-dom'
import { ParceirosBrandShell } from './ParceirosBrandShell'
import { ParceirosLoginForm } from './ParceirosLoginForm'
import { PARCEIROS_ACCENT, PARCEIROS_CADASTRO_PATH } from './parceirosBrand'

export default function ParceirosLogin() {
  return (
    <ParceirosBrandShell
      rightSlot={
        <Link
          to={PARCEIROS_CADASTRO_PATH}
          className='rounded-full px-4 py-2 text-sm font-medium text-white active:scale-95'
          style={{ background: PARCEIROS_ACCENT }}
        >
          Quero ser parceiro
        </Link>
      }
    >
      <div className='mx-auto grid max-w-lg gap-6'>
        <div>
          <p className='text-[11px] font-medium uppercase tracking-[0.28em] text-white/55'>Acesso do parceiro</p>
          <h1 className='mt-2 text-3xl font-black'>Entrar no portal</h1>
          <p className='mt-2 text-white/70'>Acompanhe suas indicações, status comercial e comissões em um só lugar.</p>
        </div>
        <ParceirosLoginForm />
      </div>
    </ParceirosBrandShell>
  )
}
